import React from "react";
import { ListGroup, Modal } from "react-bootstrap";
import "./VariationPage.css";
import { connect } from "react-redux";
import { maintainCartdata } from "../../home/redux/actions";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import CardchangePage from "../components/CardchangePage";
import { useState } from "react";
import pluse_add from "../../../assets/plus_add_white.svg";
import minus_white from "../../../assets/minus_white.svg";
import { postRequestcall } from "../../comman/util/postRequest";
import { ADD_PRODUCT_CART, CART_ITEM_DELETE } from "../../constants/apiurl";

function VariationPage(props) {
  let storeId = props?.store_id;
  const [cartclear, setCartclear] = useState(false);
  const { t } = useTranslation();
  const [productId, setProductid] = useState("");

  // Add to cart
  const addtoCart = async (e, vid) => {
    e.stopPropagation();
    if (
      props?.cartInformation?.store_id !== storeId &&
      props?.cartInformation?.store_id !== ""
    ) {
      setProductid(vid);
      setCartclear(true);
    } else {
      addProducttocart(vid);
    }
  };

  const addProducttocart = async (vid) => {
    let id = "";
    let quantity = 1;
    let pid = props?.productlist[props?.productindex]?.pid;
    let getProduct = props?.productlist.filter((item) => item.pid === pid);
    if (getProduct.length > 0) {
      if (props.access_token) {
        // If user is login
        let geturl =
          ADD_PRODUCT_CART +
          `?store_id=${storeId}&product_id=${pid}&variation_id=${vid}&quantity=${quantity}&id=${id}`;
        let getCartapiresponse = await postRequestcall(
          geturl,
          props?.access_token,
          ""
        );
        if (getCartapiresponse?.status === 200) {
          let getId = await getCartapiresponse.json();
          getId = getId?.data;
          storeCartProducts(props.productlist, getId, vid, quantity);
        }
      } else {
        storeCartProducts(props.productlist, "", vid, quantity);
      }
    }
  };

  const quantityPlus = async (e, vid, get_cart_detail) => {
    e.stopPropagation();
    let check_stock = true;
    let getid = get_cart_detail?.id;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let pid = props?.productlist[props?.productindex]?.pid;
    let getProduct = props.productlist.filter((item) => item.pid === pid);
    if (getProduct?.length > 0) {
      let getVariation = getProduct[0]?.variations.filter(
        (item) => item?.vid === vid
      );
      if (getVariation?.length !== 0) {
        if (getVariation[0]?.is_stock === "yes") {
          if (quantity + 1 > getVariation[0]?.stock) {
            check_stock = false;
            toast.error(t('pages.Out of Stock'))
            // toast.error(
            //   t("pages.You can not add more than") +
            //     " " +
            //     getVariation[0]?.stock +
            //     " " +
            //     t("pages.quantities of this product")
            // );
          }
        } else {
          check_stock = true;
        }
        if (check_stock === true) {
          if (getProduct.length > 0) {
            if (props?.access_token) {
              let geturl =
                ADD_PRODUCT_CART +
                `?store_id=${storeId}&product_id=${pid}&variation_id=${vid}&quantity=${
                  quantity + 1
                }&id=${getid}`;
              let getResponse = await postRequestcall(
                geturl,
                props?.access_token,
                ""
              );
              if (getResponse?.status === 200) {
                let id = await getResponse.json();
                updated_id = id.data;
                storeCartProducts(
                  props.productlist,
                  updated_id,
                  vid,
                  quantity + 1
                );
              }
            } else {
              storeCartProducts(props.productlist, "", vid, quantity + 1);
            }
          }
        }
      }
    }
  };

  const quantityMinus = async (e, vid, get_cart_detail) => {
    e.stopPropagation();
    let getid = get_cart_detail?.id;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let getResponse;
    let pid = props?.productlist[props?.productindex]?.pid;
    let getProduct = props?.productlist.filter((item) => item.pid === pid);
    if (getProduct.length > 0) {
      if (props.access_token) {
        if (get_cart_detail?.quantity === 1) {
          let geturl = CART_ITEM_DELETE + `?id=${getid}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        } else {
          let geturl =
            ADD_PRODUCT_CART +
            `?store_id=${storeId}&product_id=${pid}&variation_id=${vid}&quantity=${
              quantity - 1
            }&id=${getid}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        }
        if (getResponse?.status === 200) {
          if (get_cart_detail?.quantity === 1) {
            storeCartProducts(props.productlist, "", vid, null);
          } else {
            let id = await getResponse.json();
            updated_id = id?.data;
            storeCartProducts(props.productlist, updated_id, vid, quantity - 1);
          }
        }
      } else {
        if (get_cart_detail?.quantity === 1) {
          storeCartProducts(props.productlist, "", vid, null);
        } else {
          storeCartProducts(props.productlist, "", vid, quantity - 1);
        }
      }
    }
  };

  // For Before and after login maintain cart products
  const storeCartProducts = (productlist, id, vid, quantity) => {
    let productList = [];
    let cart_detail = {};
    let currentvariant = {};
    productlist.forEach((item, index) => {
      if (item.pid === props?.productlist[props?.productindex]?.pid) {
        item.variations.forEach((item) => {
          // cart_detail id and quantity updated
          if (item.vid === vid) {
            cart_detail =
              quantity === null ? null : { id: id, quantity: quantity };
            item.cart_detail = cart_detail;
          }
        });
        let getValue = item?.variations.filter((item) => item.vid === vid);
        // If first variation position add to cart
        if (productlist[index].current_vid === vid) {
          productlist[index].cart_detail = getValue[0]?.cart_detail;
        }
        productList.push(productlist[index]);
        currentvariant = getValue[0];
      } else {
        productList.push(productlist[index]);
      }
    });
    props.setProductlist(productList);
    filterCurrentorder(currentvariant, vid);
  };

  // Filter current order list update and add
  const filterCurrentorder = (variation, vid) => {
    let flag = true;
    let getProduct = props?.cartdata?.filter(
      (item) => item.variation_id === vid
    );
    let product = props?.productlist[props.productindex];
    let productObj = {
      cart_detail: variation?.cart_detail,
      id: variation?.cart_detail?.id,
      store_id: product?.store_id,
      product_id: product?.pid,
      variation_id: variation?.vid,
      quantity: variation?.cart_detail?.quantity,
      title_in_tr: product?.title_in_tr,
      product_name: product?.title,
      product_deleted_at: null,
      images: product?.images,
      img_url: product?.img_url,
      is_stock: variation?.is_stock,
      stock: variation?.stock,
      price: variation?.price,
      discount: variation?.discount,
      product_qty: variation?.quantity,
      unit_name: variation?.unit,
      unit_id: variation?.unit_id,
      variation_deleted_at: null,
      out_of_stock: variation?.out_of_stock,
      vatrate: product?.vatrate,
    };
    if (getProduct?.length !== 0) {
      props?.cartdata?.forEach((item, index) => {
        if (item.variation_id === variation?.vid) {
          if (variation?.cart_detail === null) {
            flag = false;
          } else {
            props.cartdata[index] = productObj; // update
          }
        }
      });
    } else {
      if (variation?.cart_detail === null) {
        // First time if redux does not contain value and when we minus the quantity
        flag = false;
      } else {
        props.cartdata.push(productObj); // add
      }
    }
    if (flag === false) {
      let getCart = props?.cartdata?.filter(
        (item) => item.variation_id !== variation?.vid
      );
      getCartlist(getCart, true);
    } else {
      getCartlist(props.cartdata, true);
    }
  };

  const getCartlist = (cartdata, totalAmtchange) => {
    let total_amount = 0;
    let final_vat_rate = 0;
    let final_sub_total = 0;
    if (cartdata?.length !== 0) {
      cartdata?.forEach((product) => {
        let productPrice = 0;
        let vat_rate = 0;
        let sub_total = 0;
        if (
          product?.discount !== null &&
          product?.discount !== 0 &&
          product?.discount < product?.price
        ) {
          productPrice = product?.discount * product?.quantity;
        } else {
          productPrice = product?.price * product?.quantity;
        }
        if (
          typeof product.vatrate === "undefined" ||
          product.vatrate === null
        ) {
          sub_total = productPrice;
        } else {
          sub_total = productPrice / (product.vatrate / 100 + 1);
          vat_rate = productPrice - sub_total;
          final_vat_rate = final_vat_rate + vat_rate;
        }
        final_sub_total = final_sub_total + sub_total;
        total_amount = total_amount + productPrice;
      });
      // Developer comment :: If user apply coupon or delivery charges and after that if user add product or minus product then the discount and charges will be zero
      let amount = {
        ...props.amount,
        sub_total: final_sub_total.toFixed(2),
        vat_rate: final_vat_rate.toFixed(2),
        total_amount: total_amount,
        discount: totalAmtchange === true ? 0 : props?.amount?.discount,
        charges: totalAmtchange === true ? 0 : props?.amount?.charges,
        coupon_code: totalAmtchange === true ? "" : props?.amount?.coupon_code,
        offer_id: totalAmtchange === true ? "" : props?.amount?.offer_id,
      };
      props.maintainCartdata(cartdata, amount); // maintain in redux
      //amount
      props.setNocart(false);
    } else {
      props.setNocart(true);
      props.maintainCartdata([], {}); // clear the redux cart
    }
  };

  return (
    <>
      <Modal
        className="variation-popup"
        keyboard={false}
        size="lg"
        restoreFocus={false}
        show={props.showvaration}
        onBackdropClick={()=>props.setShowvariation(false)}
        centered
      >
        <Modal.Body>
          <div
            onClick={() => props.setShowvariation(false)}
            className="close-icon"
          />
          {/* </button> */}
          <div className="row">
            <div className="col-xl-6 col-lg-6 product_detail">
              <img
                src={props?.productlist[props?.productindex]?.img_url}
                alt={"product_image"}
                className={"product_image mb-2"}
              />
              <div className="text-center">
                <h5 className="mb-1">
                  {props?.language === "Tr"
                    ? props?.productlist[props?.productindex]?.title_in_tr
                    : props?.productlist[props?.productindex]?.title}
                </h5>
                <p className="mb-0">
                {props?.language === "Tr" ? props?.productlist[props.productindex]?.description_in_tr : props?.productlist[props.productindex]?.description } 
                </p>
                <label className="pr-color">{t("pages.Product Details")}</label>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 variation_details">
              <div className="variation_lists border-left-1">
                <div className="pro_variation">
                  {props?.productlist[props?.productindex]?.variations?.map(
                    (item, index) => (
                      <ListGroup as="ol" key={index.toString()} numbered>
                        <ListGroup.Item
                          action
                          className={`d-flex justify-content-between align-items-center`}
                        >
                          <div className="ms-2 me-auto">
                            <div className="">
                              {item?.quantity}{" "}
                              {props.language === "Tr"
                                ? item?.unit_in_tr
                                : item?.unit}
                            </div>
                            {item?.discount !== null &&
                            item?.discount !== 0 &&
                            item?.discount < item?.price ? (
                              <>
                                <del style={{ color: "#8c8d9f" }}>
                                  {item?.price}{" "}
                                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                                </del>{" "}
                                <span
                                  className="product_price"
                                  style={{ marginLeft: "5px" }}
                                >
                                  {item?.discount}{" "}
                                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                                </span>
                              </>
                            ) : (
                              <span
                                className="product_price"
                                style={{ marginLeft: "5px" }}
                              >
                                {item?.price}{" "}
                                {process.env.REACT_APP_CURRENCY_SYMBOL}
                              </span>
                            )}
                          </div>
                          {props.type === "vendor" ? (
                            storeId === props?.storeDetail?.store_id ? (
                              <></>
                            ) : item?.out_of_stock === true ? (
                              <h5
                                style={{ fontSize: "15px", color: "#FF0000" }}
                              >
                                {t("pages.Out of Stock")}
                              </h5>
                            ) : item?.cart_detail ? (
                              <div className="d-flex">
                                <button
                                  className="add-to-card btn-minus pr"
                                  onClick={(e) =>
                                    quantityMinus(
                                      e,
                                      item?.vid,
                                      item?.cart_detail
                                    )
                                  }
                                >
                                  <img
                                    src={minus_white}
                                    height="18"
                                    width="18"
                                    alt="minus"
                                  />
                                </button>
                                <button className="add-to-card btn-qty pr">
                                  {item?.cart_detail?.quantity}
                                </button>
                                <button
                                  className="add-to-card  btn-add pr"
                                  onClick={(e) =>
                                    quantityPlus(
                                      e,
                                      item?.vid,
                                      item?.cart_detail
                                    )
                                  }
                                >
                                  <img
                                    src={pluse_add}
                                    height="18"
                                    width="18"
                                    alt="plus"
                                  />
                                </button>
                              </div>
                            ) : (
                              <button
                                className="green-btn  pr"
                                onClick={(e) => addtoCart(e, item?.vid)}
                              >
                                <i class="mask_icon plus_icon"/>
                                {t("pages.add")}
                              </button>
                            )
                          ) : item?.out_of_stock === true ? (
                            <h5 style={{ fontSize: "15px", color: "#FF0000" }}>
                              {t("pages.Out of Stock")}
                            </h5>
                          ) : item?.cart_detail ? (
                            <div className="d-flex">
                              <button
                                className="add-to-card btn-minus pr"
                                onClick={(e) =>
                                  quantityMinus(e, item?.vid, item?.cart_detail)
                                }
                              >
                                <img
                                  src={minus_white}
                                  height="18"
                                  width="18"
                                  alt="minus"
                                />
                              </button>
                              <button className="add-to-card btn-qty pr">
                                {item?.cart_detail?.quantity}
                              </button>
                              <button
                                className="add-to-card  btn-add pr"
                                onClick={(e) =>
                                  quantityPlus(e, item?.vid, item?.cart_detail)
                                }
                              >
                                <img
                                  src={pluse_add}
                                  height="18"
                                  width="18"
                                  alt="plus"
                                />
                              </button>
                            </div>
                          ) : (
                            <button
                              className="green-btn pr"
                              onClick={(e) => addtoCart(e, item?.vid)}
                            >
                                <i class="mask_icon plus_icon"/>

                              {t("pages.add")}
                            </button>
                          )}
                        </ListGroup.Item>
                      </ListGroup>
                    )
                  )}
                </div>
                <div
                  className="d-flex align-items-center justify-content-between py-2 px-3 pe-2 total_div"
                  style={{ visibility: "collapse" }}
                >
                  {t("pages.Item total")} | Rs.1275
                  <button
                    onClick={() => props.setShowvariation(false)}
                    className="green-btn radius-0"
                  >
                    {t("pages.done")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <CardchangePage
        cartclear={cartclear}
        cartInformation={props.cartInformation}
        setCartinformation={props.setCartinformation}
        setCartclear={setCartclear}
        addProducttocart={addProducttocart}
        productId={productId}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  type: state?.login?.type,
  storeDetail: state?.dashboard?.storeDetail,
  cartdata: state?.home?.cartdata,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { maintainCartdata })(VariationPage);
